var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 78,
    viewBox: "0 0 94 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0989 65.321C45.5993 64.8213 45.5993 64.0139 46.0989 63.5188C46.5985 63.0191 47.4059 63.0191 47.9011 63.5188C48.4007 64.0184 48.4007 64.8258 47.9011 65.321C47.4015 65.8206 46.5941 65.8206 46.0989 65.321Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 35.3838L45.18 36.5972L45.7733 34.4917L44.0558 33.1355L46.2417 33.0508L47 30.9988L47.7584 33.0508L49.9442 33.1355L48.2268 34.4917L48.8201 36.5972L47 35.3838Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3783 43.1503C55.5515 44.6714 56.2474 46.5718 56.2474 48.6282C56.2474 53.6468 52.1077 57.7196 47 57.7196C41.8923 57.7196 37.7526 53.6512 37.7526 48.6282C37.7526 46.5718 38.4485 44.6759 39.6172 43.1547C39.6128 43.2573 39.6083 43.3599 39.6083 43.4625C39.6083 47.4729 42.9138 50.7249 46.9955 50.7249C51.0773 50.7249 54.3828 47.4729 54.3828 43.4625C54.3828 43.3599 54.3828 43.2573 54.3739 43.1547L54.3783 43.1503Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.501 55.026C57.0897 51.4373 57.0897 45.6189 53.501 42.0302C49.9123 38.4415 44.0939 38.4415 40.5052 42.0302C36.9165 45.6189 36.9165 51.4373 40.5052 55.026C44.0939 58.6147 49.9123 58.6147 53.501 55.026Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6258 48.4632L61.8057 49.6766L62.399 47.571L60.6816 46.2149L62.8674 46.1301L63.6258 44.0781L64.3841 46.1301L66.57 46.2149L64.8525 47.571L65.4458 49.6766L63.6258 48.4632Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3742 48.4632L28.5542 49.6766L29.1475 47.571L27.4301 46.2149L29.6159 46.1301L30.3742 44.0781L31.1326 46.1301L33.3184 46.2149L31.601 47.571L32.1943 49.6766L30.3742 48.4632Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0846 12.0846L34.9645 34.9645",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9333 12.0668L59.031 34.9646",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5361 47H71.0041",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9959 47H0.463928",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 0.463989V26.868",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8002 14.8503L40.5718 31.3467",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8451 40.4915L79.1497 33.8002L79.1631 33.7913",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4005 14.9307L53.5218 31.3869",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9172 33.595L31.195 40.3978",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9172 33.595L31.195 40.3978",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8451 40.496L79.1541 33.8002",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8002 14.8503L40.5718 31.3512",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3159 57.425C50.2743 61.4666 43.7212 61.4666 39.6797 57.425",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7108 70.5268C45.0015 69.8175 45.0015 68.6621 45.7108 67.9529C46.4201 67.2436 47.5754 67.2436 48.2847 67.9529C48.994 68.6621 48.994 69.8175 48.2847 70.5268C47.5754 71.2361 46.4201 71.2361 45.7108 70.5268Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.287 76.9281C44.3413 75.9824 44.3413 74.4479 45.287 73.4977C46.2327 72.5475 47.7673 72.552 48.7174 73.4977C49.6632 74.4434 49.6632 75.978 48.7174 76.9281C47.7717 77.8738 46.2372 77.8738 45.287 76.9281Z",
    fill: "#FFCD83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 77.6374,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.6a6d2427446a5d5da045a60439b5a6dd.svg";
export { ForwardRef as ReactComponent };